import {
  errorCode,
  requestErrorSchema,
} from "@mjolnerbacken/shared/types/request-error";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PrimeReactProvider } from "primereact/api";
import React, { useEffect, useRef } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { Departures } from "./pages/departures";
import { Login } from "./pages/login";
import { Logout } from "./pages/logout";
import { Profile } from "./pages/profile";
import { SchoolLunch } from "./pages/school-lunch";
import { Shopping } from "./pages/shopping";
import { Takk } from "./pages/takk";
import { TakkToday } from "./pages/takk-today";
import { logout } from "./services/auth";
import { on } from "./services/event-listner";
import { useAuthStore } from "./stores/auth";

export function App() {
  const queryClient = new QueryClient();

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <PrimeReactProvider>
          <BrowserRouter>
            <Paths />
          </BrowserRouter>
        </PrimeReactProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

function Paths() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuth = useAuthStore((state) => state.setIsAuth);

  const setIsAuthRef = useRef(isAuth);
  const navigateRef = useRef(navigate);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/shopping");
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const subs = on("error", (payload: unknown) => {
      const parsedPayload = requestErrorSchema.parse(payload);

      if (parsedPayload.code === errorCode.UNAUTHORIZED) {
        logout();
        setIsAuthRef.current(false);
        navigateRef.current("/login");
      }
    });

    return () => {
      subs.unsubscribe();
    };
  });

  return (
    <Routes>
      <Route element={<Shopping />} path="/shopping" />
      <Route element={<Shopping />} path="/shopping/cart" />
      <Route element={<Shopping />} path="/shopping/dinner" />
      <Route element={<Departures />} path="/departures" />
      <Route element={<SchoolLunch />} path="/school-lunch" />
      <Route element={<Takk />} path="/takk" />
      <Route element={<TakkToday />} path="/takk-today" />
      <Route element={<Login />} path="/login" />
      <Route element={<Logout />} path="/logout" />
      <Route element={<Profile />} path="/profile" />
    </Routes>
  );
}
